import { render } from "./MpoStarChartView.vue?vue&type=template&id=9f968968&scoped=true"
import script from "./MpoStarChartView.vue?vue&type=script&lang=js"
export * from "./MpoStarChartView.vue?vue&type=script&lang=js"

import "./MpoStarChartView.vue?vue&type=style&index=0&id=9f968968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f968968"]])

export default __exports__